import React from 'react';
import { Container } from 'reactstrap';

import WhiteKeyboard from '../../assets/images/content/white_keyboard.png';

const HireMe = props => {
  return (
    <Container fluid className='py-5 bg-light mt-5 position-relative'>
      <Container>
        <div className='d-flex justify-content-center'>
          <img
            className='img-fluid bg-light'
            src={WhiteKeyboard}
            alt='White Keyboard'
            height='250'
            width='250'
            style={{
              objectFit: 'cover'
            }}
          />
        </div>
        <p className='text-center text-hire lead'>
          I'm <span className='text-primary'>available</span> <br /> for
          freelance.
        </p>
        <p className='text-muted text-center mb-0'>Email me:</p>
        <p className='mt-0 text-center'>neojay.andong@yahoo.com</p>
      </Container>
    </Container>
  );
};

export default HireMe;
